<template>
  <!-- 预渲染使用 不要删除 app 的div-->
  <div id="app">
    <div class="bg">
      <Header />
      <div class="title">
        <div class="title-one">福利一</div>
        <div class="title-two">新课上线，早鸟最高优惠2000元</div>
      </div>
      <div class="connect"></div>
      <Box1 />
      <div class="title">
        <div class="title-one">福利二</div>
        <div class="title-two" style="margin-top: 0.8rem">
          购年度会员<br />立享《360°就业通》5折，就业快人一步
        </div>
      </div>
      <div class="connect"></div>
      <Box2 />
      <div class="title">
        <div class="title-one">福利三</div>
        <div class="title-two">积小谷币换好礼，多重好礼带回家</div>
      </div>
      <div class="connect"></div>
      <Box3 />
      <div class="connect"></div>
      <Box4 />
      <div class="connect"></div>
      <Box5 />
      <div class="title">
        <div class="title-one">福利四</div>
        <div class="title-two">大数据热门课程，限时一折抢</div>
      </div>
      <div class="connect"></div>
      <Box6 />
      <div class="title">
        <div class="title-one">福利五</div>
        <div class="title-two">独家学习线路图限时免费，学IT不迷路</div>
      </div>
      <div class="connect"></div>
      <Box7 />
      <Box8 />
    </div>
    <Formpop @Get="Get()" />
    <Successpop />
    <!-- 右侧悬浮 -->
    <div class="flay" ref="flay">
      <div class="flay-txt">我的小谷币</div>
      <div class="islog" v-if="flag">
        <div class="islog-coin">{{ coin }}</div>
        <div ref="flash" @click="Flash" class="islog-flash"></div>
      </div>
      <div class="nolog" v-else>
        <div class="nolog-btn" @click="Login">登录查看</div>
      </div>
    </div>
  </div>
</template>

<script>
import check from "../../../utils/check.js";
import wechat from "../../../utils/wechat";
import { mapActions, mapState } from "vuex";
import { Configuration } from "../../../utils/buried";
export default {
  name: "App",
  components: {
    Box1: () => import("./components/Box1"),
    Box2: () => import("./components/Box2"),
    Box3: () => import("./components/Box3"),
    Box4: () => import("./components/Box4"),
    Box7: () => import("./components/Box7"),
    Box8: () => import("./components/Box8"),
    Formpop: () => import("./components/Formpop"),
    Successpop: () => import("./components/Successpop"),
    Box5: () => import("./components/Box5"),
    Box6: () => import("./components/Box6"),
    Header: () => import("./components/Header"),
  },
  data() {
    return {
      flag: false,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  methods: {
    ...mapActions(["getCoin2"]),
    async Flash() {
      this.$refs.flash.className = "islog-flash2";
      await this.getCoin2();
      setTimeout(() => {
        this.$refs.flash.className = "islog-flash";
      }, 1000);
    },
    Login() {
      this.$store.commit("Openpop", 4);
    },
    async Get() {
      this.flag = await this.getCoin2();

      setTimeout(() => {
        if (this.flag) {
          document.querySelector("#islog").style.display = "block";
          document.querySelector("#nolog").style.display = "none";
        } else {
          document.querySelector("#islog").style.display = "none";
          document.querySelector("#nolog").style.display = "block";
        }
      }, 200);
    },
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.scrollTop = window.scrollY;
    });

    this.Get();
    Configuration("h5", "20215月周年庆活动专题页");
    this.$nextTick(() => {
      window.sessionId = zhuge.getSid();
      window.sessionId += "&" + zhuge.getDid();
      zhuge.track("用户标识", {
        id: window.sessionId,
      });
    });
  },
  created() {
    let start = new Date("2021/05/10 00:00:00");
    let end = new Date("2021/05/31 23:59:00");
    setTimeout(() => {
      if (new Date() < start) {
        alert("活动未开始");
        window.location.href = "https://m.boxuegu.com";
      } else if (new Date() > end) {
        alert("活动已结束");
        window.location.href = "https://m.boxuegu.com";
      }
    }, 1000);
    //h5跳转pc
    let Ispc = check.checkIsPC();
    let base_path = "";
    if (
      window.location.origin == "https://www.boxuegu.com" ||
      window.location.origin == "https://m.boxuegu.com"
    ) {
      base_path = "https://www.boxuegu.com/subject";
    } else {
      base_path = "https://portal-ysc.boxuegu.com/subject";
    }
    setTimeout(() => {
      if (Ispc) {
        window.location.href =
          base_path + "/activity-28.html" + window.location.search;
      }
    }, 1000);

    wechat.init({
      title: "5月职场充电季活动-新课上线多重福利重磅来袭-博学谷",
      desc:
        "博学谷5月职场充电季活动，活动时间2021.5.10-5.31日，新课上线，早鸟最高优惠2000元；购年度会员，立享《360°就业通》5折，就业快人一步；积小谷币换好礼，多重好礼带回家；直面大咖讲师，get你需要的职场技能；独家学习路线图限时免费，学IT不迷路。",
      link: "https://m.boxuegu.com/campaign/activity-28.html",
      imgUrl: "https://file.boxuegu.com/img/activity/zaoniao_discounts.png",
    });
  },
  computed: {
    ...mapState(["coin"]),
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          this.$refs.flay.style.right = "0";
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
        }
      }, 20); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        this.$refs.flay.style.right = "-1.2rem";
      }
    },
  },
};
</script>

<style lang="scss">
#chatBtn {
  display: none !important;
}

.bg {
  background-color: #220066;
  .title {
    margin: 0 auto;
    overflow: hidden;
    width: 690px;
    height: 249px;
    background-image: url("./assets/title.png");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    &-one {
      margin-top: 8px;
      font-family: SourceHanSansCN-Bold;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 5px;
      color: #5530fd;
      text-align: center;
    }
    &-two {
      margin-top: 83px;
      font-family: SourceHanSansCN-Bold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #ffffff;
      text-align: center;
    }
  }
  .connect {
    margin: 0 auto;
    width: 690px;
    height: 30px;
    background-image: url("./assets/connection.png");
    background-size: 100% 100%;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.flay {
  transition: 0.5s;
  text-align: center;
  position: fixed;
  top: 100px;
  right: 0;
  z-index: 10;
  width: 195px;
  height: 156px;
  background-image: url("./assets/flay.png");
  background-size: cover;
  &-txt {
    margin-top: 36px;
    font-family: SourceHanSansCN-Bold;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    color: #674cff;
  }
  .islog {
    &-coin {
      font-family: SourceHanSansCN-Bold;
      font-size: 26px;
      font-weight: normal;
      font-stretch: normal;
      color: #f0230b;
    }
    &-flash {
      margin: 0 auto;
      width: 30px;
      height: 30px;
      background-image: url("./assets/flash.png");
      background-size: 100% 100%;
    }
    &-flash2 {
      margin: 0 auto;
      width: 30px;
      height: 30px;
      background-image: url("./assets/flash.png");
      background-size: 100% 100%;
      animation: rotate 0.5s linear infinite;
    }
  }
  .nolog {
    &-btn {
      margin: 0 auto;
      text-align: center;
      margin-top: 17px;
      width: 109px;
      height: 34px;
      background-color: #ffd336;
      border-radius: 6px;
      border: solid 1px #2a4b9e;

      font-family: SourceHanSansCN-Bold;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 34px;
      color: #674cff;
    }
  }
}
</style>
